import React from "react";
import { Trans, useTranslation } from "react-i18next";
import RelativeTime from "components/common/RelativeTime";
const IndexRangeSummary = ({ indexRange }) => {
  const { t } = useTranslation("indexsets");
  if (!indexRange) {
    return /* @__PURE__ */ React.createElement("span", null, /* @__PURE__ */ React.createElement("i", null, t("indices.range_summary.none")));
  }
  return /* @__PURE__ */ React.createElement("span", null, /* @__PURE__ */ React.createElement(
    Trans,
    {
      t,
      i18nKey: "indices.range_summary.recalculated",
      values: { ms: indexRange.took_ms },
      components: { relativeTime: /* @__PURE__ */ React.createElement(RelativeTime, { dateTime: indexRange.calculated_at }) }
    }
  ));
};
export default IndexRangeSummary;
